import React from "react";
import { Link } from "react-router-dom";
import garahexLogo from "assets/img/logo138x75white.png";

export default function BrandMark({ inverse = false, onClick }) {
  return (
    <Link
      to="/"
      className={`pl-brand${inverse ? " pl-brand--inverse" : ""}`}
      aria-label="Garahex home"
      onClick={onClick}
    >
      <span className="pl-brand__logo-window">
        <img className="pl-brand__logo" src={garahexLogo} alt="Garahex" width="138" height="75" />
      </span>
      <span className="pl-brand__copy">
        <small>Move. Connect. Deliver.</small>
      </span>
    </Link>
  );
}
